import { isPhoneInHolidayMode } from "@faire/help-center-self-serve/utils/isSupportServiceInHolidayMode";
import { getIsLoggedInUser } from "@faire/help-center-utils/serialized-data/getUser";
import { useQuery as useAccessControlQuery } from "@faire/web-api--source/endpoints/www/api/help-center/access-control/get-hooks";

type PhoneAuthResponse = {
  hasPhoneAccess: boolean;
};

export const usePhoneAuthorization = (): PhoneAuthResponse => {
  const { data } = useAccessControlQuery({
    enabled: getIsLoggedInUser(),
  });

  const hasPhoneAccess = data?.has_phone ?? false;

  if (isPhoneInHolidayMode()) {
    return {
      hasPhoneAccess: false,
    };
  }
  return {
    hasPhoneAccess,
  };
};
